<script setup>
import DropdownMenuItem from '@/components/shared/dropdown/DropdownMenuItem.vue'

//Emits and props
defineEmits([
  'toggle-unread',
  'toggle-paused',
  'manage',
])
defineProps({
  isUnread: {
    type: Boolean,
    default: false,
  },
  isPaused: {
    type: Boolean,
    default: false,
  },
  canManage: {
    type: Boolean,
    default: false,
  },
  canToggleUnread: {
    type: Boolean,
    default: false,
  },
  canTogglePaused: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <DropdownMenuItem
    v-if="canManage"
    icon="settings"
    label="Manage enrollment"
    @click="$emit('manage')"
  />
  <DropdownMenuItem
    v-if="canToggleUnread && !isUnread"
    label="Mark as unread"
    icon="mark_email_unread"
    @click="$emit('toggle-unread')"
  />
  <DropdownMenuItem
    v-if="canTogglePaused"
    :label="isPaused ? 'Resume' : 'Pause'"
    :icon="isPaused ? 'play_arrow' : 'pause'"
    @click="$emit('toggle-paused')"
  />
</template>
